/*
 * @Author: Ryan
 * @Date: 2026-02-03
 * @Description: Image data for AI Removal SEO showcase
 */
import { ImageCompareItem } from '@/landing/components/ImageCompareSlider';

export const SHOWCASE_IMAGES: ImageCompareItem[] = [
  {
    id: 'haircare-product',
    beforeUrl:
      'https://assets.falcocut.ai/ai-removal/haircare-product-logo-remover-before.webp',
    afterUrl:
      'https://assets.falcocut.ai/ai-removal/haircare-product-logo-remover-after.webp',
    thumbnailUrl:
      'https://assets.falcocut.ai/ai-removal/haircare-product-logo-remover-after.webp',
    label: 'Logo Removal',
  },
  {
    id: 'headphones-subtitle',
    beforeUrl:
      'https://assets.falcocut.ai/ai-removal/headphones-subtitle-remover-before.webp',
    afterUrl:
      'https://assets.falcocut.ai/ai-removal/headphones-subtitle-remover-after.webp',
    thumbnailUrl:
      'https://assets.falcocut.ai/ai-removal/headphones-subtitle-remover-after.webp',
    label: 'Subtitle Removal',
  },
  {
    id: 'perfume-watermark',
    beforeUrl:
      'https://assets.falcocut.ai/ai-removal/perfume-watermark-remover-before.webp',
    afterUrl:
      'https://assets.falcocut.ai/ai-removal/perfume-watermark-remover-after.webp',
    thumbnailUrl:
      'https://assets.falcocut.ai/ai-removal/perfume-watermark-remover-after.webp',
    label: 'Watermark Removal',
  },
];
